module.exports = __webpack_public_path__ + "img/logo.117778a1.png";